import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import ShopByTireSizeStatic from '../../ShopByTireSizeStatic'

const BOTSearchTrailerTires = ({ placeholders: { leftContent } = {}, queryParams = '' }) =>
  <Wrapper>
    <ShopByTireSizeStatic queryParams={ queryParams } />
    <TextWrapper>{ leftContent }</TextWrapper>
  </Wrapper>

export default BOTSearchTrailerTires

BOTSearchTrailerTires.propTypes = {
  placeholders: PropTypes.shape({
    leftContent: PropTypes.arrayOf(PropTypes.shape())
  }),
  queryParams: PropTypes.string
}

const Wrapper = styled.div`
  margin-top: 31px;
  ${Media.desktop`
    margin: 74px auto 0;
    ${Mixin.clearFix()}
  `}
`

const TextWrapper = styled.div`
  margin-top: 21px;
  padding: 0 7px;
  ${Media.desktop`
    display: inline-block;
    max-width: 56%;

    margin-top: 0;
    padding: 0;
  `}

  h1 {
    text-transform: uppercase;
    ${Mixin.responsive('margin', '0 0 10px', '3px 0 13px')}
    ${Mixin.font.GothamBold(34)}
    ${Media.mobile`
      ${Mixin.font.GothamBold(14)}
    `}
  }

  ul {
    margin: 6px 0 0;
    padding: 0 0 20px 20px;
    list-style: none;
    counter-reset: list;
    ${Media.desktop`
      padding-left: 31px;
    `}
  }

  li {
    margin: 0 0 3px;
    padding: 3px 3px 3px 15px;
    ${Media.desktop`
      margin-bottom: 5px;
    `}
  }

  p,
  li {
    font-size: 12px;
    line-height: 13px;
    ${Media.desktop`
      font-size: 15px;
      line-height: 22px;
    `}
  }

  li::before {
    float: left;
    margin-left: -14px;
    counter-increment: list;
    content: "•";
    ${Media.desktop`
      font-size: 20px;
      line-height: 24px;
    `}
  }
`
